import { keyBy } from 'lodash-es'
import { ChainId } from '@/domains/chain'

export type Menu = {
  id: string
  name: React.ReactNode
  path: string
  isActive: (pathname: string) => boolean
  isNew: boolean
  isExternal?: boolean
}

export const MenuList: Menu[] = [
  {
    id: 'InjectiveTestnetFaucet',
    name: 'Faucet',
    path: 'https://testnet.faucet.injective.network/',
    isActive: () => false,
    isNew: false,
    isExternal: true,
  },
  {
    id: 'Restake',
    name: (
      <>
        <span className={'typo-new-label-3'}>(</span>Re<span className={'typo-new-label-3'}>)</span>Stake
      </>
    ),
    path: '/restake',
    isActive: (pathname: string) => pathname.startsWith('/restake') || pathname === '/stake' || pathname === '/unstake',
    isNew: false,
  },
  {
    id: 'RestakeExternal',
    name: (
      <>
        <span className={'typo-new-label-3'}>(</span>Re<span className={'typo-new-label-3'}>)</span>Stake
      </>
    ),
    path: 'https://app.lair.fi/restake',
    isActive: () => false,
    isNew: false,
    isExternal: true,
  },
  {
    id: 'Stake',
    name: 'Stake',
    path: '/stake',
    isActive: (pathname: string) => pathname === '/stake' || pathname === '/unstake',
    isNew: false,
  },
  {
    id: 'Bridge',
    name: 'Bridge',
    path: '/bridge',
    isActive: (pathname: string) => pathname === '/bridge',
    isNew: false,
  },
  {
    id: 'Earn',
    name: 'Earn',
    path: '/earn',
    isActive: (pathname: string) => pathname === '/earn',
    isNew: false,
  },
  {
    id: 'Airdrops',
    name: 'Airdrops',
    path: '/airdrops',
    isActive: (pathname: string) => pathname === '/airdrops',
    isNew: false,
  },
  {
    id: 'LAIR',
    name: 'LAIR',
    path: '/lair',
    isActive: (pathname: string) => pathname === '/lair' || pathname === '/checker',
    isNew: false,
  },
]

const MenuMap = keyBy(MenuList, item => item.id)

export const AppMenuList: Record<ChainId, Menu[]> = {
  [ChainId.KAIA]: [MenuMap['Bridge'], MenuMap['LAIR']],
  [ChainId.KAIA_TESTNET]: [MenuMap['Bridge'], MenuMap['LAIR']],
  [ChainId.BERA]: [MenuMap['Bridge'], MenuMap['LAIR']],
  [ChainId.BERA_TESTNET]: [MenuMap['Bridge'], MenuMap['LAIR']],
  [ChainId.INJECTIVE_TESTNET]: [],
  [ChainId.SOMNIA]: [],
  [ChainId.SOMNIA_TESTNET]: [],
}

export const DesktopMenuList: Record<ChainId, Menu[]> = {
  [ChainId.KAIA]: [MenuMap['Restake'], MenuMap['Earn'], MenuMap['Airdrops']],
  [ChainId.KAIA_TESTNET]: [MenuMap['Restake'], MenuMap['Earn'], MenuMap['Airdrops']],
  [ChainId.BERA]: [MenuMap['Restake'], MenuMap['Earn'], MenuMap['Airdrops']],
  [ChainId.BERA_TESTNET]: [MenuMap['Restake'], MenuMap['Earn'], MenuMap['Airdrops']],
  [ChainId.INJECTIVE_TESTNET]: [MenuMap['Stake'], MenuMap['RestakeExternal'], MenuMap['InjectiveTestnetFaucet']],
  [ChainId.SOMNIA]: [MenuMap['Restake']],
  [ChainId.SOMNIA_TESTNET]: [MenuMap['Restake']],
}

export const MobileMenuList: Record<ChainId, Menu[]> = {
  [ChainId.KAIA]: [MenuMap['Restake'], MenuMap['Bridge'], MenuMap['Earn'], MenuMap['Airdrops'], MenuMap['LAIR']],
  [ChainId.KAIA_TESTNET]: [MenuMap['Restake'], MenuMap['Bridge'], MenuMap['Earn'], MenuMap['Airdrops'], MenuMap['LAIR']],
  [ChainId.BERA]: [MenuMap['Restake'], MenuMap['Earn'], MenuMap['Airdrops'], MenuMap['Bridge'], MenuMap['LAIR']],
  [ChainId.BERA_TESTNET]: [MenuMap['Restake'], MenuMap['Earn'], MenuMap['Airdrops'], MenuMap['Bridge'], MenuMap['LAIR']],
  [ChainId.INJECTIVE_TESTNET]: [MenuMap['Stake'], MenuMap['RestakeExternal'], MenuMap['InjectiveTestnetFaucet']],
  [ChainId.SOMNIA]: [MenuMap['Restake']],
  [ChainId.SOMNIA_TESTNET]: [MenuMap['Restake']],
}
